export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  detail: (state) => state.detail,
  effects: (state) => state.effects,
  sar: (state) => state.sar,
  types: (state) => state.types,
  txRules: (state) => state.tx?.rules,
  txTypes: (state) => state.tx?.types,
};
